import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23571dfe&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23571dfe')) {
      api.createRecord('23571dfe', component.options)
    } else {
      api.reload('23571dfe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=23571dfe&", function () {
      api.rerender('23571dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after_sales/index.vue"
export default component.exports